import React from "react";

interface SaveHeartProps {
  saved?: boolean;
  size?: number;
  width?: number;
  height?: number;
}

const SaveHeart = ({
  saved = false,
  size = 24,
  width,
  height,
}: SaveHeartProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 24 24"
      fill={saved ? "#DF1C41" : "none"}
      stroke={saved ? "" : "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-heart transition-colors ease-linear delay-150"
    >
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
    </svg>
  );
};

export default SaveHeart;
